import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import classNames from "classnames";
import useClickOutside from "../../../../utils/hooks/useClickOutside";
import ProductMultiplierHeader from "./ProductMultiplierHeader";
import ProductMultiplierItem from "./ProductMultiplierItem";
import "./ProductMultiplier.scss";
const ProductMultiplier = ({ priceTiers }) => {
    const dropdownRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const toggleDropdown = () => setIsOpen((isOpen) => !isOpen);
    const handleKeyDown = (event) => {
        const { key } = event;
        if (key === "Enter" || key === "ArrowDown") {
            setIsOpen(true);
            return;
        }
        if (key === "Escape") {
            setIsOpen(false);
        }
    };
    const className = classNames("product-multiplier", {
        "product-multiplier--open": isOpen,
    });
    const handleMultiplierItemClick = () => {
        setIsOpen(false);
    };
    useClickOutside(dropdownRef, () => setIsOpen(false));
    return (_jsx("div", { className: "product-multiplier__wrapper", children: _jsxs("div", { ref: dropdownRef, "data-testid": "product-multiplier", className: className, children: [_jsx(ProductMultiplierHeader, { handleKeyDown: handleKeyDown, toggleDropdown: toggleDropdown }), _jsx("ul", { className: "product-multiplier__list", children: priceTiers.map((priceTier) => (_jsx(ProductMultiplierItem, { item: priceTier, onItemClick: handleMultiplierItemClick }, priceTier.final_price.value))) })] }) }));
};
export default ProductMultiplier;
//# sourceMappingURL=ProductMultiplier.js.map